export function fixedTableHeadings(){
  const $win = $(window);
  const $cartForm = $('.desktop-cart .cart-form form');
  if ($cartForm.length === 0) {
    return;
  }
  const formHeight = $cartForm.height();
  const cartFormOffestTop = $cartForm.offset().top;
  const bottomLine = $cartForm.offset().top + formHeight;
  let winOffsetTop = $win.scrollTop()
  if (winOffsetTop > cartFormOffestTop && winOffsetTop < bottomLine) {
    $cartForm.find('.fixed-table').addClass('fixed');
  }else{
    $cartForm.find('.fixed-table').removeClass('fixed');
  }
}



// WEBPACK FOOTER //
// ../markup/assets/js/cart-heading.js